export const vns_permissions_index = ['vns_permissions.index']
export const vns_permissions_create = ['vns_permissions.create']
export const vns_permissions_edit = ['vns_permissions.edit']

export default [].concat(
    vns_permissions_index,
    vns_permissions_create,
    vns_permissions_edit
)
